import { Component, effect, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { Router } from '@angular/router';
import { filter, firstValueFrom, take } from 'rxjs';
import { DialogService } from '../shared/dialogs/dialog.service';
import { InputDialogType } from '../shared/dialogs/input/input.component';
import { match } from '../shared/functions/functional';
import { AuthenticationService } from './authentication.service';

@Component({
  selector: 'authentication-signin-complete',
  imports: [MatProgressBar],
  template: `<mat-progress-bar mode="indeterminate"></mat-progress-bar>`
})
export class SigninCompleteComponent {
  private readonly router = inject(Router);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly dialogService = inject(DialogService);

  private readonly signInAttempted = signal(false);

  private async resolveEmailForSignIn(): Promise<string | undefined> {
    const storedEmail = await this.authenticationService.resolveStoredEmailForSignIn();

    return match(
      async () => {
        const email = await firstValueFrom(
          this.dialogService.input(
            InputDialogType.string,
            'Email',
            'Enter your email',
            undefined,
            undefined,
            'Enter the email used to request this sign-in link.'
          )
        );

        return typeof email === 'string' ? email.trim() || undefined : undefined;
      },
      async (email: string) => email
    )(storedEmail);
  }

  _CompleteSignIn = effect(async () => {


    // Prevent multiple attempts
    if (this.signInAttempted()) return;

    this.signInAttempted.set(true);

    // Complete sign-in
    try {
      const link = window.location.href;
      const email = await this.resolveEmailForSignIn();

      if (!email) {
        this.router.navigate(['/authentication/signin']);
        return;
      }

      console.log('Attempting to complete sign-in with link:',  link);

      await this.authenticationService.completeSignInWithLink(link, email);
      await firstValueFrom(
        this.authenticationService.initialized$.pipe(
          filter(Boolean),
          take(1)
        )
      );
      this.router.navigate(['/dashboard']);
    } catch {
      this.router.navigate(['/authentication/signin']);
    }
  });
  }

